import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  DialogActions,
  DialogContent,
  Typography,
  Checkbox,
  Box,
  Card,
  CardContent,
  FormGroup,
  IconButton,
  Dialog,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { EyeOutlined, Html5Filled } from "@ant-design/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import {
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import HttpService from "../services/httpService";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { connect } from "react-redux";

function CostSummarySection(props) {
  const [loading, setLoadingState] = useState(false); // Local loading state
  const [editOpen, setEditOpen] = useState(false);
  const [mainImage, setMainImage] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [deleteModelIsOpen, setDeleteModelIsOpen] = useState(false);
  const [postModelIsOpen, setPostModelIsOpen] = useState(false);
  const [selectCategory, setSelectCategory] = useState("");
  const [allCategory, setAllCategory] = useState("");
  const [form, setForm] = useState({ title: "", imageUrl: "" });
  const [getAllCostSummary, setAllCostSummary] = useState([]);
  const [heading, setHeading] = useState("");
  const [subHeading, setSubHeading] = useState("");
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [feedback, setFeedback] = useState("");
  const [imgArray, setImgArray] = useState("");

  function editFunCloseHandle() {
    setEditOpen(false);
  }

  const costSummaryItemGet = async () => {
    try {
      setLoadingState(true);
      props.setLoading(true);
      const fetchData = await HttpService?.galleryCategoryWebQuotationGet();
      setAllCostSummary(fetchData?.data || []);
    } catch (error) {
      setLoadingState(false);
      props.setLoading(false);
    }
  };

  const getAllCategoryFun = async () => {
    try {
      setLoadingState(true);
      props.setLoading(true);
      const fetchData = await HttpService?.getAllCategory();
      setAllCategory(fetchData?.data?.data || []);
    } catch (error) {
      setLoadingState(false);
      props.setLoading(false);
    }
  };

  const handleMainImageChange = async (event, index) => {
    props.setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", event.target.files[0]);
      const fileUploadRes = await HttpService.uploadFile(fd);

      const uploadedImageUrl = fileUploadRes.data; // Assuming this is the URL string

      setImgArray((prevArray) => {
        const updatedArray = [...prevArray]; // Copy existing array
        updatedArray[index] = uploadedImageUrl; // Set image at specific index
        return updatedArray;
      });
    } catch (error) {
      props.setSnackInfo("Something went wrong", "error");
    }
    props.setLoading(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (imgArray.length < 1 || selectCategory == "" || subHeading == "") {
      props.setSnackInfo("please fill all the fields", "warning");
      return;
    }
    const obj = {
      title: selectCategory,
      description: subHeading,
      images: imgArray,
    };

    props.setLoading(true);
    try {
      props.setLoading(true);
      const response = await HttpService.galleryCategoryWebQuotationPut(
        sectionId,
        obj
      );
      costSummaryItemGet();
      setEditOpen(false);
      setHeading("");
      setSubHeading("");
      setImgArray("");

      props.setLoading(false);
      props.setSnackInfo("Sucessfully Updated", "success");
    } catch (error) {
      props.setLoading(false);
    }
  };

  const deleteContentOfCommonWebQuotationFun = async () => {
    props.setLoading(true);
    try {
      props.setLoading(true);
      const response = await HttpService.galleryCategoryWebQuotationDelete(
        sectionId
      );
      costSummaryItemGet();
      setDeleteModelIsOpen(false);
      props.setLoading(false);
      props.setSnackInfo("Item Deactivated Successfully", "success");
    } catch (error) {
      props.setLoading(false);
    }
  };

  const createSectionHandle = async (event) => {
    event.preventDefault();
    if (imgArray.length < 1 || selectCategory == "" || subHeading == "") {
      props.setSnackInfo("please fill all the fields", "warning");
      return;
    }
    const obj = {
      title: selectCategory,
      description: subHeading,
      images: imgArray,
    };

    props.setLoading(true);
    try {
      props.setLoading(true);
      const response = await HttpService.cgalleryCategoryWebQuotationPost(obj);
      costSummaryItemGet();
      setPostModelIsOpen(false);
      setHeading("");
      setSubHeading("");
      setImgArray("");
      setSelectCategory("");
      props.setLoading(false);
      props.setSnackInfo("Sucessfully Created", "success");
    } catch (error) {
      props.setLoading(false);

      // Handle category already exists error
      if (error.response && error.response.status === 400) {
        props.setSnackInfo("Category already exists", "error");
      } else {
        props.setSnackInfo("Something went wrong. Please try again!", "error");
      }
    }
  };

  const handleEdit = (item) => {
    setEditOpen(true);
    setSelectCategory(item?.title);
    setSubHeading(item?.description);
    setImgArray(item.images);
    setSectionId(item?._id);
  };

  useEffect(() => {
    costSummaryItemGet();
    getAllCategoryFun();
  }, []);

  return (
    <div>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Box
          sx={{
            fontSize: "18px",
            fontWeight: "bold",
            color: "#FFF2EB",
            background: "#1C375D",
            padding: "10px 20px",
            borderRadius: "8px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            display: "inline-block",
            marginBottom: "5px",
            cursor: "pointer",
          }}
          onClick={() => {
            setPostModelIsOpen(true);
          }}
        >
          Create Gallery
        </Box>
      </Box>

      {getAllCostSummary?.length > 0 &&
        getAllCostSummary?.map((ele, index) => {
          const isEven = index % 2 !== 0;

          return (
            <Box
              key={ele?._id}
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gridTemplateRows: "auto auto auto",
                gap: 2,
                marginBottom: "100px",
              }}
            >
              {/* TEXT Area */}
              <Box style={{ display: "flex", justifyContent: "space-between" }}>
                <Box
                  sx={{
                    gridColumn: isEven ? "2 / 4" : "1 / 3",
                    gridRow: "1 / 2",
                    bgcolor: "#f5f5f5",
                    p: 2,
                    width: "100%",
                  }}
                >
                  {/* Title and Edit/Delete Buttons in one row */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                    }}
                  >
                    <Typography
                      variant="h4"
                      style={{
                        color: "#1C375D",
                        padding: "5%",
                        paddingBottom: "2%",
                      }}
                    >
                      {ele?.title}
                    </Typography>

                    <Box>
                      <IconButton
                        onClick={() => handleEdit(ele)}
                        size="small"
                        color="primary"
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          setSectionId(ele?._id);
                          setDeleteModelIsOpen(true);
                        }}
                        size="small"
                        color="error"
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>

                  {/* Description */}
                  <Typography
                    variant="body1"
                    style={{
                      color: "#555",
                      lineHeight: 1.6,
                      // borderRight: isEven ? "2px solid gray" : "none",
                      // borderLeft: !isEven ? "2px solid gray" : "none",
                      borderRight: "2px solid gray",
                      width: "100%",
                      padding: "5%",
                    }}
                  >
                    {ele?.description}
                  </Typography>
                </Box>
              </Box>

              {/* IMG 1 - tall */}
              <Box
                sx={{
                  gridColumn: isEven ? "3 / 4" : "1 / 2",
                  gridRow: "1 / 3",
                }}
              >
                <img
                  src={ele?.images[0]}
                  alt="img1"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </Box>

              {/* IMG 3 - tall */}
              <Box
                sx={{
                  gridColumn: isEven ? "1 / 2" : "3 / 4",
                  gridRow: "2 / 4",
                }}
              >
                <img
                  src={ele.images[2]}
                  alt="img3"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </Box>

              {/* IMG 2 */}
              <Box
                sx={{
                  gridColumn: "2 / 3",
                  gridRow: "2 / 3",
                }}
              >
                <img
                  src={ele.images[1]}
                  alt="img2"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </Box>

              {/* IMG 5 */}
              <Box
                sx={{
                  gridColumn: "2 / 3",
                  gridRow: "3 / 4",
                }}
              >
                <img
                  src={ele.images[4]}
                  alt="img5"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </Box>

              {/* IMG 4 */}
              <Box
                sx={{
                  gridColumn: isEven ? "3 / 4" : "1 / 2",
                  gridRow: "3 / 4",
                }}
              >
                <img
                  src={ele.images[3]}
                  alt="img4"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </Box>
            </Box>
          );
        })}

      {/* Dialog Box for Edit content */}
      <Dialog
        open={editOpen}
        onClose={() => {}} // Prevent closing on backdrop click
        maxWidth="lg"
        PaperProps={{
          style: {
            width: "40%",
            maxHeight: "50vh",
          },
        }}
        BackdropProps={{
          style: { pointerEvents: "none" }, // Disable clicking outside
        }}
      >
        <DialogContent>
          <Box onClick={(e) => e.stopPropagation()}>
            {" "}
            {/* Prevent backdrop close */}
            <Card sx={{ maxWidth: 500, mt: 4, p: 2 }}>
              <CardContent>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="h5" gutterBottom>
                    Edit Content
                  </Typography>
                </Box>
                <form onSubmit={handleSubmit}>
                  <FormControl style={{ m: 1, minWidth: 300 }} size="small">
                    <InputLabel>Select Category</InputLabel>
                    <Select
                      value={selectCategory}
                      onChange={(e) => setSelectCategory(e.target.value)}
                    >
                      {allCategory.length > 0 &&
                        allCategory?.map((ele) => {
                          return (
                            <MenuItem value={ele?.name}>{ele?.name}</MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                  {/* <TextField
                    fullWidth
                    label="Heading"
                    value={heading}
                    onChange={(e) => setHeading(e.target.value)}
                    margin="normal"
                  /> */}
                  <TextField
                    fullWidth
                    label="Sub Heading"
                    value={subHeading}
                    onChange={(e) => setSubHeading(e.target.value)}
                    margin="normal"
                  />
                  {[1, 2, 3, 4, 5].map((ele, index) => {
                    return (
                      <Button
                        variant="contained"
                        component="label"
                        fullWidth
                        style={{
                          backgroundColor: "#355025",
                          color: "#FFF2EB",
                          marginTop: "10px",
                        }}
                      >
                        <div>
                          {" "}
                          {index + 1 == 1 || index + 1 == 3
                            ? `Upload portrait Image ${index + 1}`
                            : `Upload Image ${index + 1}`}
                          {mainImage?.name && <span>, {mainImage.name}</span>}
                        </div>
                        <input
                          type="file"
                          hidden
                          accept=".png, .jpg, .jpeg, .webp"
                          //   onChange={handleMainImageChange}

                          onChange={(e) => {
                            handleMainImageChange(e, index);
                          }}
                        />
                        <FormGroup style={{ marginLeft: "10px" }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={!!imgArray[index]}
                                color="primary"
                              />
                            }
                          />
                        </FormGroup>
                      </Button>
                    );
                  })}
                </form>
              </CardContent>
            </Card>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            style={{ backgroundColor: "#355025" }}
            variant="contained"
            color="primary"
            onClick={(e) => handleSubmit(e)}
          >
            Edit
          </Button>
          <Button
            onClick={() => {
              editFunCloseHandle();
              setSelectCategory("");
              setSubHeading("");
              setImgArray("");
              setSectionId("");
            }}
            variant="contained"
            color="secondary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Box for delete Document */}
      <Dialog
        open={deleteModelIsOpen}
        onClose={() => {
          setDeleteModelIsOpen(false);
        }}
        maxWidth="lg" // Adjust maxWidth ('xs', 'sm', 'md', 'lg', 'xl' for default sizes)
        PaperProps={{
          style: {
            width: "25%", // Set custom width
            maxHeight: "50vh", // Optionally limit height
          },
        }}
      >
        <DialogContent>
          <Typography variant="h6">
            {" "}
            Are you sure you want to delete it?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            style={
              {
                //   backgroundColor: "red",
              }
            }
            variant="contained"
            color="primary"
            onClick={() => {
              deleteContentOfCommonWebQuotationFun();
            }}
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              setDeleteModelIsOpen(false);
            }}
            variant="contained"
            color="secondary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Box for Post Document */}
      <Dialog
        open={postModelIsOpen}
        onClose={() => {
          setPostModelIsOpen(false);
        }}
        maxWidth="lg" // Adjust maxWidth ('xs', 'sm', 'md', 'lg', 'xl' for default sizes)
        PaperProps={{
          style: {
            width: "50%", // Set custom width
            maxHeight: "50vh", // Optionally limit height
          },
        }}
      >
        <DialogContent>
          <Card
            sx={{
              maxWidth: 500,
              mt: 4,
              p: 2,
            }}
          >
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="h5" gutterBottom>
                  Post Content
                </Typography>
              </Box>
              <form onSubmit={handleSubmit}>
                <FormControl style={{ m: 1, minWidth: 300 }} size="small">
                  <InputLabel>Select Category</InputLabel>
                  <Select
                    value={selectCategory}
                    onChange={(e) => setSelectCategory(e.target.value)}
                  >
                    {allCategory.length > 0 &&
                      allCategory?.map((ele) => {
                        return (
                          <MenuItem value={ele?.name}>{ele?.name}</MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
                <TextField
                  fullWidth
                  label="Sub Heading"
                  value={subHeading}
                  onChange={(e) => setSubHeading(e.target.value)}
                  margin="normal"
                />
                {[1, 2, 3, 4, 5].map((ele, index) => {
                  return (
                    <Button
                      variant="contained"
                      component="label"
                      fullWidth
                      style={{
                        backgroundColor: "#355025",
                        color: "#FFF2EB",
                        marginTop: "10px",
                      }}
                    >
                      <div>
                        {" "}
                        {index + 1 == 1 || index + 1 == 3
                          ? `Upload portrait Image ${index + 1}`
                          : `Upload Image ${index + 1}`}
                        {mainImage?.name && <span>, {mainImage.name}</span>}
                      </div>
                      <input
                        type="file"
                        hidden
                        accept=".png, .jpg, .jpeg, .webp"
                        onChange={(e) => {
                          handleMainImageChange(e, index);
                        }}
                      />
                      <FormGroup style={{ marginLeft: "10px" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={!!imgArray[index]}
                              color="primary"
                            />
                          }
                        />
                      </FormGroup>
                    </Button>
                  );
                })}
              </form>
            </CardContent>
          </Card>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => {
              createSectionHandle(e);
            }}
          >
            Save
          </Button>
          <Button
            onClick={() => {
              setPostModelIsOpen(false);
              setHeading("");
              setSubHeading("");
              setImgArray("");
              setSelectCategory("");
            }}
            variant="contained"
            color="secondary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default connect(null, { setLoading, setSnackInfo })(CostSummarySection);
